import { render, staticRenderFns } from "./GRD.vue?vue&type=template&id=6380037c"
import script from "./GRD.vue?vue&type=script&lang=js"
export * from "./GRD.vue?vue&type=script&lang=js"
import style0 from "./GRD.vue?vue&type=style&index=0&id=6380037c&prod&lang=css"
import style1 from "./GRD.vue?vue&type=style&index=1&id=6380037c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports